/**
 * Model class for Aero calendar.
 */
export class AeroCalendarPicker {
  /**
   * Minimum date for the aero calendar.
   */
  minDate : Date;

  /**
   * Maximum date for the aero calendar.
   */
  maxDate : Date;

  /**
   * Range for the aero calendar year dropdown.
   */
  range : string;
}
